module.exports = __webpack_public_path__ + "images/mdj/members/resume/quick_resume/btn_check_sp_off-2d52ab67eb9a7ac153263e45ec16e9f3.png";